module.exports = __webpack_public_path__ + "static/AngelaHe7-a59d4b616657067f19e00adbdd7b1982.webp";